import { LAYERS } from "./theme";
let dom = null;
function getDom() {
    if (dom)
        return dom;
    const el = document.createElement("div");
    el.textContent = "Verbindung unterbrochen — verbinde erneut…";
    el.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: ${LAYERS.connectionBanner};
    background: rgba(168, 58, 58, 0.95);
    color: #fff;
    text-align: center;
    padding: 6px 12px;
    font-family: ui-sans-serif, system-ui, sans-serif;
    font-size: 12px;
    font-weight: 600;
    display: none;
  `;
    document.body.appendChild(el);
    dom = { el };
    return dom;
}
export function showConnectionLostBanner() {
    getDom().el.style.display = "block";
}
export function hideConnectionLostBanner() {
    if (dom)
        dom.el.style.display = "none";
}
